/**
 * Stripe uses unix seconds format for timestamps
 */
export const unixSecondsToMilliseconds = (seconds: number) => seconds * 1000
